import { DialogHelper } from "@/helpers/dialog-helper";
import GmbVerificationDialog from "@/components/FacilityDetails/Dialog/GmbVerificationDialog";

export const GMB_CHANGE_FIELD_TYPE = {
  NAME: "name",
  ADDRESS: "address",
  CATEGORY: "category"
};

export const GMB_VERIFICATION_INFO_LINKS = {
  [GMB_CHANGE_FIELD_TYPE.NAME]: lang =>
    `https://support.google.com/business/answer/3038177?hl=${lang}#name`,
  [GMB_CHANGE_FIELD_TYPE.ADDRESS]: lang =>
    `https://support.google.com/business/answer/3038177?hl=${lang}#address`,
  [GMB_CHANGE_FIELD_TYPE.CATEGORY]: lang =>
    `https://support.google.com/business/answer/3038177?hl=${lang}#Categories`
};

export default {
  name: "GmbUpdateVerificationMixin",
  data() {
    return {
      GMB_CHANGE_FIELD_TYPE,
      GMB_VERIFICATION_INFO_LINKS
    };
  },
  methods: {
    getGmbVerificationFields(updatedFields) {
      let verificationFields = [];

      if (updatedFields.includes("name")) {
        verificationFields.push(GMB_CHANGE_FIELD_TYPE.NAME);
      }

      if (
        updatedFields.some(i =>
          [
            "street",
            "street_number",
            "postal_code",
            "city",
            "country"
          ].includes(i)
        )
      ) {
        verificationFields.push(GMB_CHANGE_FIELD_TYPE.ADDRESS);
      }

      if (
        updatedFields.some(i =>
          ["primary_category", "additional_categories"].includes(i)
        )
      ) {
        verificationFields.push(GMB_CHANGE_FIELD_TYPE.CATEGORY);
      }

      return verificationFields;
    },

    checkGmbVerificationFields(updatedFields, callback, cancelCallback) {
      const verificationFields = this.getGmbVerificationFields(updatedFields);

      if (verificationFields.length) {
        DialogHelper.showDialog(
          GmbVerificationDialog,
          {
            verificationFields
          },
          [
            {
              event: "confirm",
              callback: () => !!callback && callback()
            },
            {
              event: "cancel",
              callback: () => !!cancelCallback && cancelCallback()
            }
          ]
        );
      } else {
        callback();
      }
    }
  }
};
